import React from "react";
import { Outlet } from "react-router-dom";
import AppTopSection from "./AppTopSection";
import AppBottomNav from "./AppBottomNav";
import FloatingMariaChat from "../../features/chat/FloatingMariaChat";

export default function AppLoggedPageLayout({
  title,
  subtitle,
  profileInitial = "C",
  homePath = "/app/home",
  profilePath = "/app/profile",
  notificationMessage = "Notificações ainda estão em desenvolvimento.",
  settingsMessage = "Configurações ainda estão em desenvolvimento.",
  onNotify,
  onSettings,
  hideTopSection = false,
  children,
  containerClassName = "mx-auto w-full max-w-md md:max-w-2xl lg:max-w-3xl px-2 sm:px-4 transition-all duration-300",
  mainClassName = "",
  mainStyle = {},
}) {
  const defaultMainClassName = hideTopSection
    ? "px-1 pt-1 pb-4 relative z-[2]"
    : "rounded-2xl md:rounded-[28px] bg-[#F7F4FB] px-4 pt-5 pb-8 mt-3 relative z-[2] shadow-sm md:shadow-md border border-white/60";

  const resolvedMainClassName = mainClassName
    ? `${defaultMainClassName} ${mainClassName}`
    : defaultMainClassName;

  const content = children ?? <Outlet />;

  return (
    <div className="min-h-screen bg-[#F8F6FD] text-[#1E192B] antialiased">
      <div className={containerClassName}>
        {!hideTopSection && (
          <AppTopSection
            title={title}
            subtitle={subtitle}
            profileInitial={profileInitial}
            homePath={homePath}
            profilePath={profilePath}
            notificationMessage={notificationMessage}
            settingsMessage={settingsMessage}
            onNotify={onNotify}
            onSettings={onSettings}
          />
        )}

        <main
          className={resolvedMainClassName}
          style={{
            ...mainStyle,
            paddingBottom: "calc(84px + env(safe-area-inset-bottom))",
          }}
        >
          {content}
        </main>
      </div>

      <FloatingMariaChat />
      <AppBottomNav />
    </div>
  );
}